import http from '../plugins/axios'

export const login = async (payload) => {
  try {
    const response = await http.post(`/api/login`, payload)
    return response.data
  } catch(error) {
    throw error
  }
}

export const getUserLogin = async (params) => {
  try {
    const response = await http.get(`/api/v2/me`, { params })
    return response.data
  } catch(error) {
    throw error
  }
}

export const logout = async () => {
  try {
    const response = await http.post(`/api/v2/logout`)
    return response.data
  } catch(error) {
    throw error
  }
}